<template>
  <tr class="plc-tableRow">
    <td data-th="Height" class="plc-tableRow__cell">
      <router-link :to="{ name: 'Block', params: { id: row.height } }" class="text-link">
        {{ row.height }}
      </router-link>
    </td>
    <td data-th="Time ago" class="plc-tableRow__cell">
      <span class="text text--light">{{ time }}</span>
    </td>
    <td data-th="Transactions" class="plc-tableRow__cell">
      <span>{{ row.txCount }}</span>
      <!--      <span class="plc-tableRow__txCount">{{ row.tx.length }}</span>-->
      <!--      <gl-transaction-icon v-for="icon in icons" :key="icon" :type="icon" :in-line="true" class="plc-tableRow__txIcon" />-->
    </td>
    <td data-th="Total sent" class="plc-tableRow__cell text text--green">
      <span class="text text--green text--bold">{{ coinsSent }} PLC</span>
    </td>
    <td data-th="Block size" class="plc-tableRow__cell text text--light">
      <span class="text text--light">{{ row.size }}</span>
    </td>
    <td class="plc-tableRow__cell plc-tableRow__cell--min">
      <gl-badge text="New" :class="{ badgeHidden: !row.new }" />
    </td>
  </tr>
</template>

<script>
import GlBadge from '@gl/GlBadge'
import { formatDistance } from 'date-fns'
// import GlTransactionIcon from '@gl/GlTransaction/components/GlTransactionIcon'

export default {
  name: 'HomeHistoryRow',
  components: { GlBadge },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    time() {
      return formatDistance(new Date(this.row.time), new Date(), { addSuffix: true })
    },
    coinsSent() {
      return this.row.outputsValue / 100000000
      // return this.row.tx.reduce((a, b) => a + b.outputsValue, 0) / 100000000
    },
    // icons() {
    //   const types = this.row.tx.map(i => i.type)
    //   return [...new Set(types)].sort()
    // },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/tableRow';

.badgeHidden {
  opacity: 0;
  visibility: hidden;
}
</style>
